import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import { AuthProvider } from "./context/AuthContext";
import { reportConversion } from "./lib/gtag";
import ScrollToTop from "./components/ScrollToTop";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import FloatingCall from "./components/FloatingCall";
import ProtectedRoute from "./components/ProtectedRoute";
import AuthCallback from "./components/AuthCallback";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Login from "./pages/Login";
import Admin from "./pages/Admin";
import FreeVending from "./pages/FreeVending";
import BuyVending from "./pages/BuyVending";
import ThankYou from "./pages/ThankYou";

function AppShell() {
  const location = useLocation();

  // Track phone-call button clicks globally (fires a Google Ads conversion
  // once the "call" label is set in src/lib/gtag.js).
  React.useEffect(() => {
    const onClick = (e) => {
      const link = e.target.closest && e.target.closest('a[href^="tel:"]');
      if (link) reportConversion("call", { phone: link.getAttribute("href") });
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);

  // Handle OAuth callback FIRST (session_id arrives in the URL fragment)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  const bareRoutes = ["/login", "/admin"];
  const hideChrome = bareRoutes.some((p) => location.pathname.startsWith(p));

  return (
    <>
      <ScrollToTop />
      {!hideChrome && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/free-vending-machines-for-businesses" element={<FreeVending />} />
        <Route path="/buy-a-vending-machine" element={<BuyVending />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
      </Routes>
      {!hideChrome && <Footer />}
      {!hideChrome && <FloatingCall />}
      <Toaster />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppShell />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
